import type { AxiosInstance } from 'axios';
import axios from 'axios';

const getCsrfToken = (): string => {
  const metaElem = document.querySelector("meta[name='csrf-token']");
  if (!metaElem) {
    return '';
  }
  const csrfToken = metaElem.getAttribute('content');
  if (!csrfToken) {
    return '';
  }
  return csrfToken;
};

// XHR経由の302リダイレクトはブラウザが自動でナビゲーションしないため、明示的に遷移が必要なパスを列挙する
const FORCE_NAVIGATE_PATHS = ['/aiexpense/grace_period_expired', '/aiexpense/payment_failed'];

/* eslint-disable no-plusplus */
window.pendingRequestCount = 0;
export const createHttpClient = (): AxiosInstance => {
  const client = axios.create({
    headers: { 'X-Requested-With': 'XMLHttpRequest', 'X-CSRF-TOKEN': getCsrfToken() }
  });

  client.interceptors.request.use(config => {
    window.pendingRequestCount++;
    return config;
  }, Promise.reject);

  client.interceptors.response.use(
    response => {
      window.pendingRequestCount--;
      const responseUrl = response.request?.responseURL as string | undefined;
      if (responseUrl) {
        const pathname = new URL(responseUrl).pathname;
        if (FORCE_NAVIGATE_PATHS.includes(pathname)) {
          window.location.href = pathname;
        }
      }
      return response;
    },
    error => {
      window.pendingRequestCount--;
      return Promise.reject(error);
    }
  );

  return client;
};
/* eslint-enable no-plusplus */
